import React from "react";

const BuildingControlManagement: React.FC = () => {
    return (
        <div>
            <h1>Building Control Management</h1>
        </div>
    );
};

export default BuildingControlManagement;